<template>
    <div
        class="modal fade"
        id="addNewRecordModal"
        tabindex="-1"
        aria-labelledby="addNewRecordModalLabel"
        aria-hidden="true"
    >
        <div
            class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg"
        >
            <form
                class="modal-content"
                @submit.prevent="addNewRecord"
                enctype="multipart/form-data"
            >
                <div class="modal-header bg-c-secondary text-white">
                    <h5 class="modal-title" id="addNewRecordModalLabel">
                        {{ localise("new_record", "add_new_record") }}
                    </h5>
                    <button
                        @click="closeModal"
                        type="button"
                        class="btn p-1 d-flex align-items-center justify-content-center"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    >
                        <i class="fas fa-times fa-lg text-white"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row justify-content-center">
                        <h5 v-if="type === 'transports'" class="mb-3 fw-bold">
                            <i class="fas fa-user-tie"></i>
                            {{ localise("new_record", "your_status") }}
                        </h5>
                        <div
                            v-if="type === 'transports'"
                            class="d-flex flex-wrap align-items-center gap-3 mb-3"
                        >
                            <div class="form-check">
                                <input
                                    v-model="transport_type"
                                    class="form-check-input"
                                    type="radio"
                                    name="transport_type"
                                    id="transport_type_physical"
                                    value="physical"
                                />
                                <label
                                    class="form-check-label"
                                    for="transport_type_physical"
                                >
                                    {{
                                        localise(
                                            "new_record",
                                            "physical_person"
                                        )
                                    }}
                                </label>
                            </div>
                            <div class="form-check">
                                <input
                                    v-model="transport_type"
                                    class="form-check-input"
                                    type="radio"
                                    name="transport_type"
                                    id="transport_type_juridical"
                                    value="juridical"
                                />
                                <label
                                    class="form-check-label"
                                    for="transport_type_juridical"
                                >
                                    {{
                                        localise(
                                            "new_record",
                                            "juridical_person"
                                        )
                                    }}
                                </label>
                            </div>
                        </div>
                        <h5 class="mb-3 fw-bold">
                            <i class="fas fa-info-circle"></i>
                            {{ localise("new_record", "main_information") }}
                        </h5>
                        <div
                            v-if="type !== 'agencies' && type !== 'guides'"
                            class="col-12 mt-2 mb-4"
                            :class="
                                type === 'transports'
                                    ? 'col-md-6'
                                    : 'col-md-6 col-lg-4'
                            "
                        >
                            <label for="category_id" class="form-label"
                                >{{ localise("new_record", "category") }}
                                <span class="text-danger ms-1">*</span></label
                            >
                            <select
                                id="category_id"
                                name="category_id"
                                type="text"
                                class="form-select py-3 rounded-c-3"
                                :class="
                                    v$.category_id.$error ? 'is-invalid' : ''
                                "
                                v-model="category_id"
                            >
                                <option value=""></option>
                                <option
                                    v-for="category in categories"
                                    :key="category.id"
                                    :value="category.id"
                                >
                                    {{
                                        category[`name_${$store.state.locale}`]
                                    }}
                                </option>
                            </select>

                            <div
                                v-if="v$.category_id.required"
                                class="invalid-feedback"
                            >
                                {{ localise("validation", "required_field") }}
                            </div>
                        </div>
                        <div
                            v-if="type !== 'guides'"
                            class="col-12 mt-2 mb-4"
                            :class="
                                type === 'agencies'
                                    ? ''
                                    : type === 'transports'
                                    ? 'col-md-6'
                                    : 'col-md-6 col-lg-4'
                            "
                        >
                            <label for="municipality_id" class="form-label"
                                >{{
                                    localise("new_record", "city_municipality")
                                }}
                                <span class="text-danger ms-1">*</span></label
                            >
                            <select
                                id="municipality_id"
                                name="municipality_id"
                                type="text"
                                class="form-select py-3 rounded-c-3"
                                :class="
                                    v$.municipality_id.$error
                                        ? 'is-invalid'
                                        : ''
                                "
                                v-model="municipality_id"
                            >
                                <option value=""></option>
                                <option
                                    v-for="municipality in municipalities"
                                    :key="municipality.id"
                                    :value="municipality.id"
                                >
                                    {{
                                        municipality[
                                            `name_${$store.state.locale}`
                                        ]
                                    }}
                                </option>
                            </select>

                            <div
                                v-if="v$.municipality_id.required"
                                class="invalid-feedback"
                            >
                                {{ localise("validation", "required_field") }}
                            </div>
                        </div>
                        <div
                            v-if="
                                type !== 'agencies' &&
                                type !== 'transports' &&
                                type !== 'guides'
                            "
                            class="col-12 col-md-6 col-lg-4 mt-2 mb-4"
                        >
                            <label for="village_id" class="form-label"
                                >{{ localise("new_record", "village") }}
                            </label>
                            <select
                                id="village_id"
                                name="village_id"
                                type="text"
                                class="form-select py-3 rounded-c-3"
                                v-model="village_id"
                            >
                                <option value=""></option>
                                <option
                                    v-for="village in villages"
                                    :key="village.id"
                                    :value="village.id"
                                >
                                    {{ village[`name_${$store.state.locale}`] }}
                                </option>
                            </select>
                        </div>
                        <div class="col-12 mt-2 mb-4">
                            <label for="title" class="form-label">
                                <span
                                    v-if="
                                        type === 'guides' ||
                                        (type === 'transports' &&
                                            transport_type === 'physical')
                                    "
                                    >{{
                                        localise("new_record", "full_name")
                                    }}</span
                                >
                                <span v-else>{{
                                    localise("new_record", "title")
                                }}</span>
                                <span class="text-danger ms-1">*</span></label
                            >
                            <input
                                id="title"
                                name="title"
                                type="text"
                                class="form-control py-3 rounded-c-3"
                                :class="v$.title.$error ? 'is-invalid' : ''"
                                v-model="title"
                            />

                            <div
                                v-if="v$.title.minLength"
                                class="invalid-feedback"
                            >
                                {{ localise("validation", "min5") }}
                            </div>
                        </div>
                        <h5 class="mb-3 fw-bold">
                            <i class="fas fa-phone-alt"></i>
                            {{ localise("new_record", "contact_information") }}
                        </h5>
                        <div
                            class="col-12 mt-2 mb-4"
                            :class="type === 'guides' ? 'col-md-6' : 'col-md-4'"
                        >
                            <label for="phone" class="form-label"
                                >{{ localise("tour_form", "phone")
                                }}<span class="text-danger ms-1">*</span></label
                            >
                            <input
                                id="phone"
                                name="phone"
                                type="number"
                                class="form-control py-3 rounded-c-3"
                                :class="v$.phone.$error ? 'is-invalid' : ''"
                                v-model="phone"
                            />

                            <div
                                v-if="v$.phone.minLength"
                                class="invalid-feedback"
                            >
                                {{ localise("validation", "phone") }}
                            </div>
                        </div>
                        <div
                            class="col-12 col-md-4 mt-2 mb-4"
                            :class="type === 'guides' ? 'col-md-6' : 'col-md-4'"
                        >
                            <label for="email" class="form-label"
                                >{{ localise("tour_form", "email")
                                }}<span class="text-danger ms-1">*</span></label
                            >
                            <input
                                id="email"
                                name="email"
                                type="email"
                                class="form-control py-3 rounded-c-3"
                                :class="v$.email.$error ? 'is-invalid' : ''"
                                v-model="email"
                            />

                            <div v-if="v$.email.email" class="invalid-feedback">
                                {{ localise("validation", "email") }}
                            </div>
                        </div>
                        <div
                            v-if="type !== 'guides'"
                            class="col-12 col-md-4 mt-2 mb-4"
                        >
                            <label for="website" class="form-label"
                                >{{ localise("good_host", "website") }}
                            </label>
                            <input
                                id="website"
                                name="website"
                                type="text"
                                class="form-control py-3 rounded-c-3"
                                v-model="website"
                            />
                        </div>
                        <div
                            v-if="
                                type === 'hotels' ||
                                type === 'restaurants' ||
                                type === 'agencies' ||
                                (type === 'transports' &&
                                    transport_type === 'juridical')
                            "
                            class="col-12 col-md-6 mt-2 mb-4"
                        >
                            <label for="director" class="form-label"
                                >{{ localise("new_record", "director")
                                }}<span
                                    v-if="type !== 'transports'"
                                    class="text-danger ms-1"
                                    >*</span
                                ></label
                            >
                            <input
                                id="director"
                                name="director"
                                type="text"
                                class="form-control py-3 rounded-c-3"
                                :class="v$.director.$error ? 'is-invalid' : ''"
                                v-model="director"
                            />

                            <div
                                v-if="v$.director.minLength"
                                class="invalid-feedback"
                            >
                                {{ localise("validation", "min5") }}
                            </div>
                            <div class="row">
                                <div class="col-12 mt-2 mb-4">
                                    <label
                                        for="director_phone"
                                        class="form-label"
                                        >{{
                                            localise(
                                                "new_record",
                                                "director_phone"
                                            )
                                        }}<span
                                            v-if="type !== 'transports'"
                                            class="text-danger ms-1"
                                            >*</span
                                        ></label
                                    >
                                    <input
                                        id="director_phone"
                                        name="director_phone"
                                        type="number"
                                        class="form-control py-3 rounded-c-3"
                                        :class="
                                            v$.director_phone.$error
                                                ? 'is-invalid'
                                                : ''
                                        "
                                        v-model="director_phone"
                                    />

                                    <div
                                        v-if="v$.director_phone.minLength"
                                        class="invalid-feedback"
                                    >
                                        {{ localise("validation", "phone") }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            v-if="
                                type === 'hotels' ||
                                type === 'restaurants' ||
                                type === 'agencies' ||
                                (type === 'transports' &&
                                    transport_type === 'juridical')
                            "
                            class="col-12 col-md-6 mt-2 mb-4"
                        >
                            <label for="manager" class="form-label"
                                >{{ localise("new_record", "manager")
                                }}<span
                                    v-if="type !== 'transports'"
                                    class="text-danger ms-1"
                                    >*</span
                                ></label
                            >
                            <input
                                id="manager"
                                name="manager"
                                type="text"
                                class="form-control py-3 rounded-c-3"
                                :class="v$.manager.$error ? 'is-invalid' : ''"
                                v-model="manager"
                            />

                            <div
                                v-if="v$.manager.minLength"
                                class="invalid-feedback"
                            >
                                {{ localise("validation", "min5") }}
                            </div>
                            <div class="row">
                                <div class="col-12 mt-2 mb-4">
                                    <label
                                        for="manager_phone"
                                        class="form-label"
                                        >{{
                                            localise(
                                                "new_record",
                                                "manager_phone"
                                            )
                                        }}<span
                                            v-if="type !== 'transports'"
                                            class="text-danger ms-1"
                                            >*</span
                                        ></label
                                    >
                                    <input
                                        id="manager_phone"
                                        name="manager_phone"
                                        type="number"
                                        class="form-control py-3 rounded-c-3"
                                        :class="
                                            v$.manager_phone.$error
                                                ? 'is-invalid'
                                                : ''
                                        "
                                        v-model="manager_phone"
                                    />

                                    <div
                                        v-if="v$.manager_phone.minLength"
                                        class="invalid-feedback"
                                    >
                                        {{ localise("validation", "phone") }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            v-if="type !== 'guides'"
                            class="col-12 col-md-6 mt-2 mb-4"
                        >
                            <label for="street_id" class="form-label"
                                >{{ localise("new_record", "street") }}
                            </label>
                            <select
                                id="street_id"
                                name="street_id"
                                type="text"
                                class="form-select py-3 rounded-c-3"
                                v-model="street_id"
                            >
                                <option value=""></option>
                                <option
                                    v-for="street in streets"
                                    :key="street.id"
                                    :value="street.id"
                                >
                                    {{ street[`name_${$store.state.locale}`] }}
                                </option>
                            </select>
                        </div>
                        <div
                            v-if="type !== 'guides'"
                            class="col-12 col-md-6 mt-2 mb-4"
                        >
                            <label for="address" class="form-label"
                                >{{ localise("new_record", "address") }} №
                            </label>
                            <input
                                id="address"
                                name="address"
                                type="text"
                                class="form-control py-3 rounded-c-3"
                                v-model="address"
                            />
                        </div>
                        <h5 class="mb-3 fw-bold">
                            <i class="fas fa-plus-circle"></i>
                            {{
                                localise("new_record", "additional_information")
                            }}
                        </h5>
                        <div
                            v-if="type === 'hotels'"
                            class="col-12 col-md-4 mt-2 mb-4"
                        >
                            <label for="stars" class="form-label"
                                >{{ localise("new_record", "stars") }}
                            </label>
                            <input
                                id="stars"
                                name="stars"
                                type="number"
                                class="form-control py-3 rounded-c-3"
                                v-model="stars"
                            />
                        </div>
                        <div
                            v-if="type === 'hotels'"
                            class="col-12 col-md-4 mt-2 mb-4"
                        >
                            <label for="rooms" class="form-label"
                                >{{ localise("new_record", "rooms") }}
                                <span class="text-danger ms-1">*</span>
                            </label>
                            <input
                                id="rooms"
                                name="rooms"
                                type="number"
                                class="form-control py-3 rounded-c-3"
                                :class="v$.rooms.$error ? 'is-invalid' : ''"
                                v-model="rooms"
                            />

                            <div
                                v-if="v$.rooms.required"
                                class="invalid-feedback"
                            >
                                {{ localise("validation", "required_field") }}
                            </div>
                        </div>
                        <div
                            v-if="type === 'hotels' || type === 'restaurants'"
                            class="col-12 mt-2 mb-4"
                            :class="
                                type === 'hotels'
                                    ? 'col-md-4'
                                    : type === 'restaurants'
                                    ? 'col-md-12'
                                    : ''
                            "
                        >
                            <label for="beds" class="form-label">
                                <span v-if="type === 'hotels'">{{
                                    localise("new_record", "beds")
                                }}</span>
                                <span v-if="type === 'restaurants'">{{
                                    localise("new_record", "seats")
                                }}</span>
                                <span class="text-danger ms-1">*</span>
                            </label>
                            <input
                                id="beds"
                                name="beds"
                                type="number"
                                class="form-control py-3 rounded-c-3"
                                :class="v$.beds.$error ? 'is-invalid' : ''"
                                v-model="beds"
                            />

                            <div
                                v-if="v$.beds.required"
                                class="invalid-feedback"
                            >
                                {{ localise("validation", "required_field") }}
                            </div>
                        </div>
                        <div
                            v-if="
                                type !== 'guides' &&
                                transport_type !== 'physical'
                            "
                            class="col-12 col-md-6 mt-2 mb-4"
                        >
                            <label for="check_in" class="form-label">
                                <span v-if="type === 'hotels'">{{
                                    localise("new_record", "check_in")
                                }}</span>
                                <span
                                    v-if="
                                        type === 'restaurants' ||
                                        type === 'entertainments' ||
                                        type === 'agencies' ||
                                        type === 'transports'
                                    "
                                    >{{
                                        localise("new_record", "hours_from")
                                    }}</span
                                >
                                <span class="text-danger ms-1">*</span>
                            </label>
                            <input
                                id="check_in"
                                name="check_in"
                                type="time"
                                class="form-control py-3 rounded-c-3"
                                :class="v$.check_in.$error ? 'is-invalid' : ''"
                                v-model="check_in"
                            />

                            <div
                                v-if="v$.check_in.required"
                                class="invalid-feedback"
                            >
                                {{ localise("validation", "required_field") }}
                            </div>
                        </div>
                        <div
                            v-if="
                                type !== 'guides' &&
                                transport_type !== 'physical'
                            "
                            class="col-12 col-md-6 mt-2 mb-4"
                        >
                            <label for="check_out" class="form-label">
                                <span v-if="type === 'hotels'">{{
                                    localise("new_record", "check_out")
                                }}</span>
                                <span
                                    v-if="
                                        type === 'restaurants' ||
                                        type === 'entertainments' ||
                                        type === 'agencies' ||
                                        type === 'transports'
                                    "
                                    >{{
                                        localise("new_record", "hours_to")
                                    }}</span
                                >
                                <span class="text-danger ms-1">*</span>
                            </label>
                            <input
                                id="check_out"
                                name="check_out"
                                type="time"
                                class="form-control py-3 rounded-c-3"
                                :class="v$.check_out.$error ? 'is-invalid' : ''"
                                v-model="check_out"
                            />

                            <div
                                v-if="v$.check_out.required"
                                class="invalid-feedback"
                            >
                                {{ localise("validation", "required_field") }}
                            </div>
                        </div>
                        <div
                            v-if="type !== 'transports'"
                            class="col-12 col-md-6 mt-2 mb-4"
                        >
                            <label for="price_from" class="form-label"
                                >{{ localise("new_record", "price_from") }}
                            </label>
                            <input
                                id="price_from"
                                name="price_from"
                                type="number"
                                class="form-control py-3 rounded-c-3"
                                v-model="price_from"
                            />
                        </div>
                        <div
                            v-if="type !== 'transports'"
                            class="col-12 col-md-6 mt-2 mb-4"
                        >
                            <label for="price_to" class="form-label"
                                >{{ localise("new_record", "price_to") }}
                            </label>
                            <input
                                id="price_to"
                                name="price_to"
                                type="number"
                                class="form-control py-3 rounded-c-3"
                                v-model="price_to"
                            />
                        </div>
                        <div v-if="type !== 'guides'" class="col-12 mt-2 mb-4">
                            <label for="services" class="form-label"
                                ><strong>{{
                                    localise("new_record", "services")
                                }}</strong>
                            </label>
                            <div class="row g-2">
                                <div
                                    v-for="service in services"
                                    :key="service.id"
                                    class="col-6 col-md-4"
                                >
                                    <div class="form-check">
                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            :value="service.id"
                                            :id="`services-${service.id}`"
                                            v-model="selectedServices"
                                        />
                                        <label
                                            class="form-check-label"
                                            :for="`services-${service.id}`"
                                        >
                                            {{
                                                service[
                                                    `name_${$store.state.locale}`
                                                ]
                                            }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            v-if="
                                type === 'hotels' ||
                                type === 'restaurants' ||
                                type === 'agencies'
                            "
                            class="col-12 mt-2 mb-4"
                        >
                            <label for="seasons" class="form-label"
                                ><strong>
                                    {{ localise("new_record", "seasons") }}
                                </strong>
                            </label>
                            <div class="row g-2">
                                <div
                                    v-for="season in seasons"
                                    :key="season.id"
                                    class="col-6 col-md-3"
                                >
                                    <div class="form-check">
                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            :value="season.id"
                                            :id="`seasons-${season.id}`"
                                            v-model="selectedSeasons"
                                        />
                                        <label
                                            class="form-check-label"
                                            :for="`seasons-${season.id}`"
                                        >
                                            {{
                                                season[
                                                    `name_${$store.state.locale}`
                                                ]
                                            }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            v-if="type === 'restaurants'"
                            class="col-12 mt-2 mb-4"
                        >
                            <label for="cuisines" class="form-label"
                                ><strong>{{
                                    localise("new_record", "cuisines")
                                }}</strong>
                            </label>
                            <div class="row g-2">
                                <div
                                    v-for="cuisine in cuisines"
                                    :key="cuisine.id"
                                    class="col-6 col-md-3"
                                >
                                    <div class="form-check">
                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            :value="cuisine.id"
                                            :id="`cuisines-${cuisine.id}`"
                                            v-model="selectedCuisines"
                                        />
                                        <label
                                            class="form-check-label"
                                            :for="`cuisines-${cuisine.id}`"
                                        >
                                            {{
                                                cuisine[
                                                    `name_${$store.state.locale}`
                                                ]
                                            }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            v-if="type === 'restaurants'"
                            class="col-12 mt-2 mb-4"
                        >
                            <label for="wines" class="form-label"
                                ><strong>{{
                                    localise("new_record", "wines")
                                }}</strong>
                            </label>
                            <div class="row g-2">
                                <div
                                    v-for="wine in wines"
                                    :key="wine.id"
                                    class="col-6 col-md-3"
                                >
                                    <div class="form-check">
                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            :value="wine.id"
                                            :id="`wines-${wine.id}`"
                                            v-model="selectedWines"
                                        />
                                        <label
                                            class="form-check-label"
                                            :for="`wines-${wine.id}`"
                                        >
                                            {{
                                                wine[
                                                    `name_${$store.state.locale}`
                                                ]
                                            }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            v-if="type === 'agencies'"
                            class="col-12 mt-2 mb-4"
                        >
                            <label for="countries" class="form-label"
                                ><strong>{{
                                    localise("new_record", "countries")
                                }}</strong>
                            </label>
                            <div class="row g-2">
                                <div
                                    v-for="country in countries"
                                    :key="country.id"
                                    class="col-6 col-md-3"
                                >
                                    <div class="form-check">
                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            :value="country.id"
                                            :id="`countries-${country.id}`"
                                            v-model="selectedCountries"
                                        />
                                        <label
                                            class="form-check-label"
                                            :for="`countries-${country.id}`"
                                        >
                                            {{
                                                $store.state.locale === "ka"
                                                    ? country.name
                                                    : country.name_en
                                            }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            v-if="type === 'hotels'"
                            class="col-12 col-md-6 mt-2 mb-4"
                        >
                            <div class="form-check form-switch">
                                <input
                                    class="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    id="adapted_room"
                                    v-model="adapted_room"
                                />
                                <label
                                    class="form-check-label"
                                    for="adapted_room"
                                    >{{
                                        localise("new_record", "adapted_room")
                                    }}</label
                                >
                            </div>
                            <div v-if="adapted_room" class="col-12 mt-2 mb-4">
                                <label for="adapted_count" class="form-label"
                                    >{{ localise("new_record", "quantity") }}
                                    <span class="text-danger ms-1">*</span>
                                </label>
                                <input
                                    id="adapted_count"
                                    name="adapted_count"
                                    type="number"
                                    class="form-control py-3 rounded-c-3"
                                    :class="
                                        v$.adapted_count.$error
                                            ? 'is-invalid'
                                            : ''
                                    "
                                    v-model="adapted_count"
                                />

                                <div
                                    v-if="v$.adapted_count.required"
                                    class="invalid-feedback"
                                >
                                    {{
                                        localise("validation", "required_field")
                                    }}
                                </div>
                            </div>
                        </div>
                        <div
                            v-if="type === 'hotels'"
                            class="col-12 col-md-6 mt-2 mb-4"
                        >
                            <div class="form-check form-switch">
                                <input
                                    class="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    id="president_suite_room"
                                    v-model="president_suite_room"
                                />
                                <label
                                    class="form-check-label"
                                    for="president_suite_room"
                                    >{{
                                        localise(
                                            "new_record",
                                            "president_suite_room"
                                        )
                                    }}</label
                                >
                            </div>
                            <div
                                v-if="president_suite_room"
                                class="col-12 mt-2 mb-4"
                            >
                                <label for="president_count" class="form-label"
                                    >{{ localise("new_record", "quantity") }}
                                    <span class="text-danger ms-1">*</span>
                                </label>
                                <input
                                    id="president_count"
                                    name="president_count"
                                    type="number"
                                    class="form-control py-3 rounded-c-3"
                                    :class="
                                        v$.president_count.$error
                                            ? 'is-invalid'
                                            : ''
                                    "
                                    v-model="president_count"
                                />

                                <div
                                    v-if="v$.president_count.required"
                                    class="invalid-feedback"
                                >
                                    {{
                                        localise("validation", "required_field")
                                    }}
                                </div>
                            </div>
                        </div>
                        <div
                            v-if="type === 'restaurants'"
                            class="col-12 col-md-4 mt-2 mb-4"
                        >
                            <div class="form-check form-switch">
                                <input
                                    class="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    id="live_music"
                                    v-model="live_music"
                                />
                                <label
                                    class="form-check-label"
                                    for="live_music"
                                    >{{
                                        localise("new_record", "live_music")
                                    }}</label
                                >
                            </div>
                        </div>
                        <div
                            v-if="type === 'restaurants'"
                            class="col-12 col-md-4 mt-2 mb-4"
                        >
                            <div class="form-check form-switch">
                                <input
                                    class="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    id="lunch_menu"
                                    v-model="lunch_menu"
                                />
                                <label
                                    class="form-check-label"
                                    for="lunch_menu"
                                    >{{
                                        localise("new_record", "lunch_menu")
                                    }}</label
                                >
                            </div>
                        </div>
                        <div
                            v-if="type === 'restaurants'"
                            class="col-12 col-md-4 mt-2 mb-4"
                        >
                            <div class="form-check form-switch">
                                <input
                                    class="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    id="pandus"
                                    v-model="pandus"
                                />
                                <label class="form-check-label" for="pandus">{{
                                    localise("new_record", "pandus")
                                }}</label>
                            </div>
                        </div>
                        <div
                            class="col-12 mt-2 mb-4"
                            :class="
                                type === 'guides' ||
                                transport_type === 'physical'
                                    ? 'col-md-6'
                                    : 'col-md-4'
                            "
                        >
                            <label for="open_year" class="form-label">
                                <span v-if="type !== 'guides'">{{
                                    transport_type !== "physical"
                                        ? localise("new_record", "open_year")
                                        : localise(
                                              "datatables",
                                              "car_release_year"
                                          )
                                }}</span>
                                <span v-else>{{
                                    localise("new_record", "birth_year")
                                }}</span>
                                <span class="text-danger ms-1">*</span>
                            </label>
                            <input
                                id="open_year"
                                name="open_year"
                                type="number"
                                class="form-control py-3 rounded-c-3"
                                :class="v$.open_year.$error ? 'is-invalid' : ''"
                                v-model="open_year"
                            />

                            <div
                                v-if="v$.open_year.required"
                                class="invalid-feedback"
                            >
                                {{ localise("validation", "required_field") }}
                            </div>
                        </div>

                        <div
                            v-if="transport_type === 'physical'"
                            class="col-12 col-md-6 mt-2 mb-4"
                        >
                            <label for="car_seats" class="form-label">
                                <span>{{
                                    localise("datatables", "seats")
                                }}</span>
                                <span class="text-danger ms-1">*</span>
                            </label>
                            <input
                                id="car_seats"
                                name="car_seats"
                                type="number"
                                class="form-control py-3 rounded-c-3"
                                :class="v$.car_seats.$error ? 'is-invalid' : ''"
                                v-model="car_seats"
                            />

                            <div
                                v-if="v$.car_seats.required"
                                class="invalid-feedback"
                            >
                                {{ localise("validation", "required_field") }}
                            </div>
                        </div>
                        <div
                            v-if="type === 'guides'"
                            class="col-12 col-md-6 mt-2 mb-4"
                        >
                            <label for="experience" class="form-label">
                                {{ localise("new_record", "experience") }}
                                <span class="text-danger ms-1">*</span>
                            </label>
                            <input
                                id="experience"
                                name="experience"
                                type="number"
                                class="form-control py-3 rounded-c-3"
                                :class="
                                    v$.experience.$error ? 'is-invalid' : ''
                                "
                                v-model="experience"
                            />

                            <div
                                v-if="v$.experience.required"
                                class="invalid-feedback"
                            >
                                {{ localise("validation", "required_field") }}
                            </div>
                        </div>
                        <div v-if="type === 'guides'" class="col-12 mt-2 mb-4">
                            <label for="categories" class="form-label"
                                ><strong>{{
                                    localise("new_record", "languages")
                                }}</strong>
                            </label>
                            <div class="row g-2">
                                <div
                                    v-for="category in categories"
                                    :key="category.id"
                                    class="col-6 col-md-4"
                                >
                                    <div class="form-check">
                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            :value="category.id"
                                            :id="`categories-${category.id}`"
                                            v-model="selectedCategories"
                                        />
                                        <label
                                            class="form-check-label"
                                            :for="`categories-${category.id}`"
                                        >
                                            {{
                                                category[
                                                    `name_${$store.state.locale}`
                                                ]
                                            }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="type === 'guides'" class="col-12 mt-2 mb-4">
                            <label for="associations" class="form-label"
                                ><strong>{{
                                    localise("new_record", "associations")
                                }}</strong>
                            </label>
                            <div class="row g-2">
                                <div
                                    v-for="association in associations"
                                    :key="association.id"
                                    class="col-6 col-md-4"
                                >
                                    <div class="form-check">
                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            :value="association.id"
                                            :id="`associations-${association.id}`"
                                            v-model="selectedAssociations"
                                        />
                                        <label
                                            class="form-check-label"
                                            :for="`associations-${association.id}`"
                                        >
                                            {{
                                                association[
                                                    `name_${$store.state.locale}`
                                                ]
                                            }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="type === 'guides'" class="col-12 mt-2 mb-4">
                            <div class="form-check form-switch">
                                <input
                                    class="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    id="certified"
                                    v-model="certified"
                                />
                                <label
                                    class="form-check-label"
                                    for="certified"
                                    >{{
                                        localise("new_record", "certified")
                                    }}</label
                                >
                            </div>
                        </div>
                        <div
                            v-if="
                                type !== 'guides' &&
                                this.transport_type !== 'physical'
                            "
                            class="col-12 col-md-4 mt-2 mb-4"
                        >
                            <label for="lat" class="form-label"
                                >{{ localise("new_record", "lat") }}
                            </label>
                            <input
                                id="lat"
                                name="lat"
                                type="text"
                                class="form-control py-3 rounded-c-3"
                                v-model="lat"
                            />
                        </div>
                        <div
                            v-if="
                                type !== 'guides' &&
                                this.transport_type !== 'physical'
                            "
                            class="col-12 col-md-4 mt-2 mb-4"
                        >
                            <label for="long" class="form-label"
                                >{{ localise("new_record", "long") }}
                            </label>
                            <input
                                id="long"
                                name="long"
                                type="text"
                                class="form-control py-3 rounded-c-3"
                                v-model="long"
                            />
                        </div>
                        <h5 class="mb-3 fw-bold">
                            <i class="fas fa-images"></i>
                            {{ localise("new_record", "media") }}
                        </h5>
                        <div class="col-12 mt-2 mb-4">
                            <input
                                id="files"
                                name="files"
                                type="file"
                                ref="fileInput"
                                class="form-control"
                                @change="uploadFiles"
                                accept="image/*"
                                multiple
                            />
                        </div>
                    </div>
                </div>
                <div
                    class="modal-footer d-flex flex-column align-items-center justify-content-center"
                >
                    <button
                        type="submit"
                        class="btn btn-sm btn-c-secondary shadow rounded-c-3 px-5 py-3 text-white"
                        :disabled="$store.state.loading"
                    >
                        <div
                            v-if="$store.state.loading"
                            class="spinner-grow spinner-grow-sm text-white"
                            role="status"
                        >
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        <span v-else>
                            <i class="fas fa-paper-plane me-1"></i>
                            {{ localise("global", "send") }}
                        </span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import translations from "../../helpers/translations";
import useVuelidate from "@vuelidate/core";
import { required, email, minLength, maxLength } from "@vuelidate/validators";
import {
    addData,
    getStreetsData,
    getSeasonsData,
    getServicesData,
    getCuisinesData,
    getWinesData,
    getCountriesData,
    getAssociationsData,
    upload,
} from "../../services/ExternalApiService";

export default {
    name: "AddNewRecord",
    props: ["type", "isOpened", "categories", "municipalities", "villages"],
    setup() {
        return {
            v$: useVuelidate(),
        };
    },
    data() {
        return {
            streets: [],
            services: [],
            selectedServices: [],
            seasons: [],
            selectedSeasons: [],
            cuisines: [],
            selectedCuisines: [],
            wines: [],
            selectedWines: [],
            countries: [],
            selectedCountries: [],
            associations: [],
            selectedAssociations: [],
            selectedCategories: [],
            category_id: "",
            municipality_id: "",
            village_id: "",
            title: "",
            phone: "",
            email: "",
            director: "",
            director_phone: "",
            manager: "",
            manager_phone: "",
            website: "",
            street_id: "",
            address: "",
            price_from: null,
            price_to: null,
            open_year: null,
            lat: null,
            long: null,
            image: null,
            gallery_id: null,
            stars: null,
            rooms: null,
            beds: null, // Using for restaurants too as seats
            check_in: null, // Using for restaurants too as hours_from
            check_out: null, // Using for restaurants too as hours_to
            adapted_room: 0,
            adapted_count: null,
            president_suite_room: 0,
            president_count: null,
            live_music: false,
            lunch_menu: false,
            pandus: false,
            experience: null,
            certified: false,
            transport_type: "",
            car_seats: null,
        };
    },
    validations() {
        const validations = {
            category_id:
                this.type !== "agencies" && this.type !== "guides"
                    ? { required }
                    : {},
            municipality_id: this.type !== "guides" ? { required } : {},
            title: { required, minLength: minLength(5) },
            phone: {
                required,
                minLength: minLength(9),
                maxLength: maxLength(9),
            },
            email: { required, email },
            director:
                this.type === "hotels" ||
                this.type === "restaurants" ||
                this.type === "agencies"
                    ? { required, minLength: minLength(5) }
                    : {},
            director_phone: this.director
                ? {
                      required,
                      minLength: minLength(9),
                      maxLength: maxLength(9),
                  }
                : {},
            manager:
                this.type === "hotels" ||
                this.type === "restaurants" ||
                this.type === "agencies"
                    ? { required, minLength: minLength(5) }
                    : {},
            manager_phone: this.manager
                ? {
                      required,
                      minLength: minLength(9),
                      maxLength: maxLength(9),
                  }
                : {},
            open_year: { required },
            rooms: this.type === "hotels" ? { required } : {},
            beds:
                this.type === "hotels" || this.type === "restaurants"
                    ? { required }
                    : {}, // Using for restaurants tooas seats
            check_in:
                this.type === "guides"
                    ? {}
                    : this.type === "transports" &&
                      this.transport_type === "physical"
                    ? {}
                    : { required },
            check_out:
                this.type === "guides"
                    ? {}
                    : this.type === "transports" &&
                      this.transport_type === "physical"
                    ? {}
                    : { required },
            adapted_count: this.adapted_room ? { required } : {},
            president_count: this.president_suite_room ? { required } : {},
            experience: this.type === "guides" ? { required } : {},
            car_seats:
                this.type === "transports" && this.transport_type === "physical"
                    ? { required }
                    : {},
        };

        return validations;
    },
    watch: {
        isOpened() {
            if (this.type !== "guides") {
                this.getStreets();
                this.getServices();
            }

            if (
                this.type === "hotels" ||
                this.type === "restaurants" ||
                this.type === "agencies"
            ) {
                this.getSeasons();
            }

            if (this.type === "restaurants") {
                this.getCuisines();
                this.getWines();
            }

            if (this.type === "agencies") {
                this.getCountries();
            }

            if (this.type === "guides") {
                this.getAssociations();
            }
        },
    },
    methods: {
        addNewRecord() {
            this.v$.$validate();
            this.v$.$touch();
            if (!this.v$.$invalid) {
                this.$store.state.loading = true;
                setTimeout(() => {
                    addData(this.type, {
                        category_id: this.category_id,
                        municipality_id: this.municipality_id,
                        village_id: this.village_id,
                        name_ka: this.title,
                        name_en: this.title,
                        name_ru: this.title,
                        mobile: this.phone,
                        email: this.email,
                        website: this.website,
                        manager:
                            this.director || this.manager
                                ? `${
                                      this.director
                                          ? `დირექტორი: ${this.director} - ${this.director_phone}, `
                                          : ""
                                  }${
                                      this.manager
                                          ? `მენეჯერი: ${this.manager} - ${this.manager_phone}`
                                          : ""
                                  }`
                                : "",
                        street_id: this.street_id,
                        address_number: this.address,
                        price_from: this.price_from,
                        price_to: this.price_to,
                        open_year:
                            this.transport_type !== "physical"
                                ? this.open_year
                                : null,
                        car_release_year:
                            this.transport_type === "physical"
                                ? this.open_year
                                : null,
                        lat: this.lat,
                        long: this.long,
                        image: this.image,
                        gallery_id: this.gallery_id,
                        for_birdwatchers: 0,
                        on_visitajara: 0,
                        status: 0,
                        // Hotels
                        stars: this.stars,
                        rooms: this.rooms,
                        beds: this.beds,
                        check_in: this.check_in,
                        check_out: this.check_out,
                        adapted_room: this.adapted_room,
                        adapted_count: this.adapted_count,
                        president_suite_room: this.president_suite_room,
                        president_count: this.president_count,
                        // Hotels
                        // Restaurants
                        seats:
                            this.type !== "transports"
                                ? this.beds
                                : this.car_seats,
                        hours_from: this.check_in,
                        hours_to: this.check_out,
                        live_music: this.live_music,
                        lunch_menu: this.lunch_menu,
                        pandus: this.pandus,
                        // Restaurants
                        // Guides
                        birth_year: this.open_year,
                        experience: this.experience,
                        is_certified: this.certified,
                        // Guides
                        services: this.selectedServices,
                        seasons: this.selectedSeasons,
                        cuisines: this.selectedCuisines,
                        wines: this.selectedWines,
                        countries: this.selectedCountries,
                        associations: this.selectedAssociations,
                        categories: this.selectedCategories,
                    })
                        .then((res) => {
                            this.$store.state.loading = false;
                            if (res.status === 200) {
                                Swal.fire({
                                    position: "center",
                                    icon: "success",
                                    text: this.localise(
                                        "new_record",
                                        "add_message"
                                    ),
                                    showConfirmButton: true,
                                    confirmButtonText: this.localise(
                                        "good_host",
                                        "close"
                                    ),
                                });
                                this.closeModal();
                                this.clearInputs();
                            } else {
                                Swal.fire({
                                    position: "center",
                                    icon: "warning",
                                    title: this.localise("validation", "error"),
                                    showConfirmButton: false,
                                    timer: 1500,
                                });
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                            this.$store.state.loading = false;
                            Swal.fire({
                                position: "center",
                                icon: "warning",
                                title: this.localise("validation", "error"),
                                showConfirmButton: false,
                                timer: 1500,
                            });
                        });
                }, 0);
            } else {
                console.log(this.v$.$errors);
                Swal.fire({
                    position: "center",
                    icon: "error",
                    title: this.localise("validation", "error"),
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
        },
        getStreets() {
            getStreetsData()
                .then((res) => (this.streets = res.data))
                .catch(console.error());
        },
        getServices() {
            getServicesData(this.type)
                .then((res) => (this.services = res.data))
                .catch(console.error());
        },
        getSeasons() {
            getSeasonsData()
                .then((res) => (this.seasons = res.data))
                .catch(console.error());
        },
        getCuisines() {
            getCuisinesData()
                .then((res) => (this.cuisines = res.data))
                .catch(console.error());
        },
        getWines() {
            getWinesData()
                .then((res) => (this.wines = res.data))
                .catch(console.error());
        },
        getCountries() {
            getCountriesData()
                .then((res) => (this.countries = res.data))
                .catch(console.error());
        },
        getAssociations() {
            getAssociationsData()
                .then((res) => (this.associations = res.data))
                .catch(console.error());
        },
        clearValidation() {
            if (!document.querySelector(".modal.show")) {
                this.v$.$reset();
            }
        },
        closeModal() {
            let newRecordModal = document.querySelector(".modal.show");
            let modal = bootstrap.Modal.getInstance(newRecordModal);
            modal.hide();

            this.$emit("changeIsOpened", false);
        },
        clearInputs() {
            this.category_id = "";
            this.municipality_id = "";
            this.village_id = "";
            this.title = "";
            this.phone = "";
            this.email = "";
            this.director = "";
            this.director_phone = "";
            this.manager = "";
            this.manager_phone = "";
            this.website = "";
            this.street_id = "";
            this.address = "";
            this.price_from = null;
            this.price_to = null;
            this.open_year = null;
            this.lat = null;
            this.long = null;
            this.image = null;
            this.gallery_id = null;
            // Hotels
            this.stars = null;
            this.rooms = null;
            this.beds = null; // Using for restaurants
            this.check_in = null; // Using for restaurants
            this.check_out = null; // Using for restaurants
            this.adapted_room = 0;
            this.adapted_count = null;
            this.president_suite_room = 0;
            this.president_count = null;
            // Hotels
            // Restaurants
            this.live_music = false;
            this.lunch_menu = false;
            this.pandus = false;
            // Restaurants
            // Guides
            this.experience = null;
            this.certified = false;
            // Guides
            this.transport_type = "physical";
            this.selectedServices = [];
            this.selectedSeasons = [];
            this.selectedCuisines = [];
            this.selectedWines = [];
            this.selectedCountries = [];
            this.selectedAssociations = [];
            this.selectedCategories = [];
            this.car_seats = null;

            this.v$.$reset();
        },
        localise(cat, key) {
            return translations[this.$store.state.locale][cat][key];
        },
        uploadFiles() {
            const files = this.$refs.fileInput.files;
            const formData = new FormData();

            for (let i = 0; i < files.length; i++) {
                formData.append("files[]", files[i]);
            }

            this.$store.state.loading = true;
            upload(formData)
                .then((res) => {
                    this.$store.state.loading = false;
                    if (res.status === 200) {
                        let data = res.data.data;

                        this.image = data.mainImage;
                        this.gallery_id = data.galleryId || null;
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.$store.state.loading = false;
                    Swal.fire({
                        position: "center",
                        icon: "warning",
                        title: this.localise("validation", "file_size"),
                        showConfirmButton: false,
                        timer: 3000,
                    });
                });
        },
    },
    mounted() {
        if (this.type === "transports") {
            this.transport_type = "physical";
        } else {
            this.transport_type = "";
        }
    },
};
</script>
